const translations = {
  en: {
    "Have a referral code?": "Have a referral code?",
    "Add a referral code": "Add a referral code",
    "Enter the code a friend shared with you.":
      "Enter the code a friend shared with you.",
    "e.g. LXmWwn": "e.g. LXmWwn",
    "Apply code": "Apply code",
    "We don't recognise that code. Check it and try again.":
      "We don't recognise that code. Check it and try again.",
    "Referral code ": "Referral code ",
    " applied": " applied",
    " not applied": " not applied",
    Back: "Back",
  },
  "zh-tw": {
    "Have a referral code?": "有推薦碼嗎？",
    "Add a referral code": "新增推薦碼",
    "Enter the code a friend shared with you.": "輸入朋友分享給你的推薦碼。",
    "e.g. LXmWwn": "例如 LXmWwn",
    "Apply code": "套用推薦碼",
    "We don't recognise that code. Check it and try again.":
      "我們無法辨識這組推薦碼，請確認後再試一次。",
    "Referral code ": "推薦碼 ",
    " applied": " 已套用",
    " not applied": " 未套用",
    Back: "返回",
  },
};

export default translations;
